<template>
  <div class="listvip">
    <div class="list1">
      <el-table :data="tableData1" border>
        <el-table-column
          align="center"
          width="336px"
          prop="name"
          label="权益明细"
        >
        </el-table-column>
        <el-table-column align="center" prop="people" label="基础协作版">
          <template slot-scope="scope">
            <span v-if="scope.row.people != ''">{{ scope.row.people }}</span>
            <i v-else class="iconfont icon-duigou" style="color: #1cb343"></i>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="num" label="高级协作版">
          <template slot-scope="scope">
            <span v-if="scope.row.num != ''">{{ scope.row.num }}</span>
            <i v-else class="iconfont icon-duigou" style="color: #1cb343"></i>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="vip" label="企业旗舰版">
          <template slot-scope="scope">
            <span v-if="scope.row.vip != ''">{{ scope.row.vip }}</span>
            <i v-else class="iconfont icon-duigou" style="color: #1cb343"></i>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="list2" style="margin-top: -1px">
      <el-table :data="tableData2" :header-cell-style="handerMethod" border>
        <el-table-column label="定制设计" align="center">
          <el-table-column
            label="根据客户需求提供相关设计服务"
            prop="name"
            width="336px"
            align="center"
          >
          </el-table-column>
          <el-table-column
            label="1次"
            align="center"
            prop="people"
          ></el-table-column>
          <el-table-column label="2次" align="center" prop="num">
          </el-table-column>
          <el-table-column
            label="可定制"
            align="center"
            prop="vip"
          ></el-table-column>
        </el-table-column>
      </el-table>
    </div>
    <div class="list3" style="margin-top: -1px">
      <el-table :data="tableData3" :header-cell-style="handerMethod" border>
        <el-table-column label="团队协作" align="center">
          <el-table-column align="center" prop="name" width="336px">
            <template slot-scope="scope">
              <span v-if="scope.row.name != ''">{{ scope.row.name }}</span>
              <i v-else class="iconfont icon-duigou" style="color: #1cb343"></i>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="people">
            <template slot-scope="scope">
              <span v-if="scope.row.people != ''">{{ scope.row.people }}</span>
              <i v-else class="iconfont icon-duigou" style="color: #1cb343"></i>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="num">
            <template slot-scope="scope">
              <span v-if="scope.row.num != ''">{{ scope.row.num }}</span>
              <i v-else class="iconfont icon-duigou" style="color: #1cb343"></i>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="vip">
            <template slot-scope="scope">
              <span v-if="scope.row.vip != ''">{{ scope.row.vip }}</span>
              <i v-else class="iconfont icon-duigou" style="color: #1cb343"></i>
            </template>
          </el-table-column>
        </el-table-column>
      </el-table>
    </div>
    <div class="list4" style="margin-top: -1px">
      <el-table :data="tableData4" :header-cell-style="handerMethod" border>
        <el-table-column label="专属授权" align="center">
          <el-table-column align="center" prop="name" width="336px">
            <template slot-scope="scope">
              <span v-if="scope.row.name != ''">{{ scope.row.name }}</span>
              <i v-else class="iconfont icon-duigou" style="color: #1cb343"></i>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="people">
            <template slot-scope="scope">
              <span v-if="scope.row.people != ''">{{ scope.row.people }}</span>
              <i v-else class="iconfont icon-duigou" style="color: #1cb343"></i>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="num">
            <template slot-scope="scope">
              <span v-if="scope.row.num != ''">{{ scope.row.num }}</span>
              <i v-else class="iconfont icon-duigou" style="color: #1cb343"></i>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="vip">
            <template slot-scope="scope">
              <span v-if="scope.row.vip != ''">{{ scope.row.vip }}</span>
              <i v-else class="iconfont icon-duigou" style="color: #1cb343"></i>
            </template>
          </el-table-column>
        </el-table-column>
      </el-table>
    </div>
    <div class="list5" style="margin-top: -1px">
      <el-table :data="tableData5" :header-cell-style="handerMethod" border>
        <el-table-column label="专属服务" align="center">
          <el-table-column align="center" prop="name" width="336px">
            <template slot-scope="scope">
              <span v-if="scope.row.name != ''">{{ scope.row.name }}</span>
              <i v-else class="iconfont icon-duigou" style="color: #1cb343"></i>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="people">
            <template slot-scope="scope">
              <span v-if="scope.row.people != ''">{{ scope.row.people }}</span>
              <i v-else class="iconfont icon-duigou" style="color: #1cb343"></i>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="num">
            <template slot-scope="scope">
              <span v-if="scope.row.num != ''">{{ scope.row.num }}</span>
              <i v-else class="iconfont icon-duigou" style="color: #1cb343"></i>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="vip">
            <template slot-scope="scope">
              <span v-if="scope.row.vip != ''">{{ scope.row.vip }}</span>
              <i v-else class="iconfont icon-duigou" style="color: #1cb343"></i>
            </template>
          </el-table-column>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tableData1: [
        {
          name: "成员数量",
          people: "1-5人",
          num: "1-10人",
          vip: "可定制",
        },
        {
          name: "原创版权模版",
          people: "30W+精美模版",
          num: "30W+精美模版",
          vip: "30W+精美模版",
        },
        {
          name: "爱设计版权图片",
          people: "50张",
          num: "150张",
          vip: "可定制",
        },
        {
          name: "爱设计版权字体",
          people: "200+正版字体",
          num: "200+正版字体",
          vip: "200+正版字体",
        },
        {
          name: "一键抠图",
          people: "",
          num: "",
          vip: "",
        },
        {
          name: "上传PSD文件",
          people: "",
          num: "",
          vip: "",
        },
        {
          name: "微信小程序VIP",
          people: "同享VIP特权",
          num: "同享VIP特权",
          vip: "同享VIP特权",
        },
        {
          name: "云端存储空间",
          people: "10G",
          num: "10G",
          vip: "可定制",
        },
        {
          name: "高峰优先下载权",
          people: "5倍速下载",
          num: "10倍速下载",
          vip: "10倍速下载",
        },
        {
          name: "VIP尊贵标识",
          people: "",
          num: "",
          vip: "",
        },
      ],
      tableData2: [
        {
          name: "根据客户需求提供相关设计服务",
          people: "1次",
          num: "2次",
          vip: "可定制",
        },
      ],
      tableData3: [
        {
          name: "团队创建",
          people: "",
          num: "",
          vip: "",
        },
        {
          name: "权限设置",
          people: "",
          num: "",
          vip: "",
        },
        {
          name: "账号批量创建",
          people: "",
          num: "",
          vip: "",
        },
        {
          name: "团队模版库",
          people: "",
          num: "",
          vip: "",
        },
        {
          name: "品牌标识锁定",
          people: "",
          num: "",
          vip: "",
        },
        {
          name: "品牌字体上传控制管理",
          people: "",
          num: "",
          vip: "",
        },
        {
          name: "多平台操作",
          people: "",
          num: "",
          vip: "",
        },
        {
          name: "品牌管理",
          people: "",
          num: "",
          vip: "",
        },
        {
          name: "企业素材管理",
          people: "",
          num: "",
          vip: "",
        },
        {
          name: "多层级文件夹",
          people: "",
          num: "",
          vip: "",
        },
        {
          name: "协同编辑",
          people: "",
          num: "",
          vip: "",
        },
      ],
      tableData4: [
        {
          name: "授权主体",
          people: "企业",
          num: "企业",
          vip: "企业",
        },
        {
          name: "授权主体数量",
          people: "1",
          num: "5",
          vip: "可定制",
        },
        {
          name: "影视传媒用途：电影、电视剧、网络电影、网剧等视频设计用途",
          people: "",
          num: "",
          vip: "",
        },
        {
          name: "影视传媒用途：电影、电视剧、网络电影、网剧等视频设计用途",
          people: "",
          num: "",
          vip: "",
        },
        {
          name:
            "网络推广用途：网站、网店站外推广设计用途（百度推广、淘宝直通车等）",
          people: "",
          num: "",
          vip: "",
        },
        {
          name: "视频广告用途：企业对外发布的视频广告设计用途",
          people: "",
          num: "",
          vip: "",
        },
        {
          name: "新媒体用途：微博、微信、头条、抖音等新媒体文章配图、短视频等",
          people: "",
          num: "",
          vip: "",
        },
        {
          name: "新媒体用途：微博、微信、头条、抖音等新媒体文章配图、短视频等",
          people: "",
          num: "",
          vip: "",
        },
        {
          name: "数字用途：网站设计用途；软件、app、小程序内设计用途  ",
          people: "",
          num: "",
          vip: "",
        },
        {
          name: "网络视频用途：如抖音、优酷、YouTube等网络视频等媒体播放平台",
          people: "",
          num: "",
          vip: "",
        },
        {
          name: "办公设计用途：PPT、工作汇报、商业提案、策划案等用途",
          people: "",
          num: "",
          vip: "",
        },
        {
          name: "户外广告用途：户外广告（报纸杂志广告 、楼宇、灯箱等）设计用途",
          people: "可定制",
          num: "可定制",
          vip: "可定制",
        },
        {
          name: "VI用途：企业VI、宣传册等设计用途（商标、LOGO除外）",
          people: "可定制",
          num: "可定制",
          vip: "可定制",
        },
        {
          name:
            "包装设计用途：用于市场流通的食品、百货等实物产品的包装设计用途",
          people: "可定制",
          num: "可定制",
          vip: "可定制",
        },
        {
          name:
            "转售品设计用途：字帖、手机壳、明信片、日历、杯子、T恤等设计用途",
          people: "可定制",
          num: "可定制",
          vip: "可定制",
        },
      ],
      tableData5: [
        {
          name: "VIP专属客服",
          people: "7*8小时VIP在线服务支持 ",
          num: "7*8小时VIP在线服务支持 ",
          vip: "7*8小时VIP在线服务支持 ",
        },
        {
          name: "用户培训 ",
          people: "",
          num: "",
          vip: "",
        },
        {
          name: "正规企业发票",
          people: "",
          num: "",
          vip: "",
        },
      ],
    };
  },
  methods: {
    //隐藏表头
    handerMethod({ rowIndex }) {
      if (rowIndex === 1) {
        //这里为了是将第二列的表头隐藏，就形成了合并表头的效果
        return { display: "none" };
      }
    },
  },
};
</script>
<style scoped lang="scss">
.list1 {
  ::v-deep( .is-leaf) {
    border-right: 1px solid #ebeef5 !important;
  }
  ::v-deep( .el-table td) {
    border-bottom: 1px solid #ebeef5 !important;
  }
  ::v-deep( .el-table th.is-leaf) {
    border-bottom: 1px solid #ebeef5 !important;
  }
}
::v-deep( .el-table .el-table__header-wrapper) {
  border-radius: 0;
}
::v-deep( .el-table th) {
  background: #f7f7fa !important;
}
::v-deep( .el-table tr) {
  height: 0 !important;
}
::v-deep( .el-table tr .cell) {
  line-height: 22px;
}
::v-deep( .el-table tr td) {
  height: 64px !important;
}
::v-deep( .el-table th) {
  height: 64px !important;
}
::v-deep( tr) {
  pointer-events: none;
}
::v-deep( th) {
  font-size: 20px;
}
::v-deep( td) {
  font-size: 16px;
}
.icon-duigou {
  font-size: 20px;
}
</style>
